"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxArrivalScanEntity = void 0;
var BoxArrivalScanEntity;
(function (BoxArrivalScanEntity) {
    BoxArrivalScanEntity["CDSKU"] = "CDSKU";
    BoxArrivalScanEntity["SELLER_LPN"] = "SELLER_LPN";
    BoxArrivalScanEntity["INBOUND_PACKAGE_TRACKING_CODE"] = "INBOUND_PACKAGE_TRACKING_CODE";
    BoxArrivalScanEntity["UNDELIVERABLE_PACKAGE_TRACKING_CODE"] = "UNDELIVERABLE_PACKAGE_TRACKING_CODE";
    BoxArrivalScanEntity["RETURNS_PACKAGE_TRACKING_CODE"] = "RETURNS_PACKAGE_TRACKING_CODE";
    BoxArrivalScanEntity["PALLET_LABEL"] = "PALLET_LABEL";
    BoxArrivalScanEntity["ASN_LABEL"] = "ASN_LABEL";
    BoxArrivalScanEntity["PREP"] = "PREP";
    BoxArrivalScanEntity["UNKNOWN"] = "UNKNOWN";
})(BoxArrivalScanEntity = exports.BoxArrivalScanEntity || (exports.BoxArrivalScanEntity = {}));
//# sourceMappingURL=BoxArrivalScan.js.map